const initState = {
    expense: [
        {id:'1',description: 'aaa', amount: '9',category: 'Entertainment', date: '01/02/2020'},
        {id:'2',description: 'aab', amount: '19',category: 'Essentials', date: '01/03/2020'},
        {id:'3',description: 'aac', amount: '29',category: 'Apparels', date: '03/02/2020'},
        {id:'4',description: 'aad', amount: '9',category: 'Food', date: '01/04/2020'},
        {id:'5',description: 'aae', amount: '6',category: 'Rent', date: '01/06/2020'},
        {id:'6',description: 'aaf', amount: '2',category: 'Miscellaneous', date: '01/09/2020'}
    ]
}
// Switch case to validate the adding expense  and catching errors while adding expenses if found any.
const expenseReducer = (state = initState, action) =>{
    switch(action.type){
        case 'ADD_EXPENSE' :
            console.log('added expense',action.expense);
                return state;
            case 'ADD_EXPENSE_ERROR' :
             console.log('added expense error',action.err);
                return state;
            default:
                return state;
    }
 }
export default expenseReducer